import { Monitor, MonitorSpec } from 'src/app/models/monitor';
import {
  ListMonitorFailuresOptions,
  ListMonitorsOptions,
} from './monitors.service';

export class LoadMonitorsAction {
  static readonly type = '[Monitors] Load monitors';
  constructor(
    public options: ListMonitorsOptions,
    /** Keep current entities on screen while re-fetching (no skeleton). */
    public refresh = false
  ) {}
}

export class LoadMonitorsForServiceAction {
  static readonly type = '[Monitors] Load monitors for service';
  constructor(
    public serviceId: number,
    public options: ListMonitorsOptions
  ) {}
}

export class GetMonitorAction {
  static readonly type = '[Monitor] Load the requested monitor';
  constructor(public monitorId: string) {}
}

export class UpdateMonitorAction {
  static readonly type = '[Monitor] Update monitor';
  constructor(
    public monitor: Monitor,
    public spec: Partial<MonitorSpec>
  ) {}
}

export class CreateMonitorAction {
  static readonly type = '[Monitor] Create monitor';
  constructor(public spec: MonitorSpec) {}
}

export class DeleteMonitorAction {
  static readonly type = '[Monitor] Delete monitor';
  constructor(public monitorId: string) {}
}

export class MonitorUpdatedAction {
  static readonly type = '[Monitor] Monitor updated';
  constructor(public monitor: Monitor) {}
}

export class LoadProberRegionsAction {
  static readonly type = '[Monitor] Load prober regions';
}

export class LoadRegionHealthAction {
  static readonly type = '[Monitor] Load region health';
  constructor(
    public monitorId: string,
    public refresh = false
  ) {}
}

export class LoadMonitorFailuresAction {
  static readonly type = '[Monitor] Load monitor failures';
  constructor(
    public monitorId: string,
    public options: ListMonitorFailuresOptions,
    public refresh: boolean
  ) {}
}
